import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux'
import renderHTML from 'react-render-html';
import gsap from 'gsap';
import apiJSON from '../../../api/apiJSON';
import {find} from 'lodash';
import './VideoRating.sass';
import serialize from 'form-serialize';
import Feedback from './Feedback/Feedback';
import Questions from './Questions/Questions';
import Rater from './Rater';
import StandardButton from "../../ui/Button/StandardButton";
import {debug} from "prettier/doc";

const VideoRating = ({data, completed, next}) => {
    const [counter, setCounter] = useState(0);
    const [showNextButton, setShowNextButton] = useState(0);
    const [selection, setSelection] = useState(-1);
    const [showRater, setShowRater] = useState(0);
    const [showResponse, setShowResponse] = useState(true);
    const [feedbackToggled, setFeedbackToggled] = useState(false);
    const [showQuestions, setShowQuestions] = useState(0);
    const [showVideo, setShowVideo] = useState(true);
    const [choiceSet, setChoiceSet] = useState({});
    const [answers, setAnswers] = useState([]);

    // load activity json file
    const jsonData = apiJSON.get(data);
    const {scenarios} = jsonData;
    const scenario = scenarios[counter];
    const debug = useSelector((state) => (state.course.debug))
    let formRef = useRef();
    let videoTag = useRef();
    let videoResponseTag = useRef();
    let slider = useRef(null);
    let fbComp = useRef(null);

    const {instructions, video} = scenario;
    const {body, title, feedback, choices} = choiceSet;
    const responseVideo = choiceSet.video;

    useEffect(() => {
        gsap.from('.video', {x: -1600});
    }, []);

    const finished = () => {
        completed();
    };

    const handleSelection = (newValue) => {
        setSelection(newValue);
    };

    const skip = () => {
        if (videoTag.current) {
            videoTag.current.pause();
        }

        gsap.set('.rater', {clearProps: 'x'});
        setTimeout(function () {
            setShowRater(1);
            gsap.from('.rater', {x: 1600});
        }, 0);
    };

    const showChoices = () => {
        let choice;
        switch (selection) {
            case 0:
                choice = 'good';
                break;
            case 1:
                choice = 'ok';
                break;
            case 2:
                choice = 'bad';
                break;
            default:
                break;
        }

        let {choiceSet} = scenario;
        choiceSet = find(choiceSet, {label: choice});
        setShowVideo(false);
        setShowRater(false);
        setShowQuestions(true);
        setShowResponse(true);
        setChoiceSet(choiceSet);
        gsap.set('.questions,.response,.rater', {clearProps: 'x'});

        setTimeout(function () {
            gsap.to('.video', {x: -1600});
            gsap.to('.rater', {x: 1600});
            gsap.set('.questions', {display: 'block'});
            gsap.set('.response', {display: 'flex'});
            gsap.from('.questions', {x: 1600});
            gsap.from('.response', {x: -1600});
        }, 0);
    };

    useEffect(() => {
        console.log("VideoRating useEffect(feedbackToggled)");
        if (feedbackToggled) {
            gsap.set('.feedback', {display: 'block'});
            gsap.fromTo('.feedback', {x: -1600}, {x: 0, ease: "expo.out", delay: 0.5});
            gsap.to(".response", {x: -1600, ease: "expo.out"})
        } else {
            gsap.to('.feedback', {x: -1600, ease: "expo.out"})
            gsap.to('.response', {x: 0, ease: "expo.out"})
        }
    }, [feedbackToggled])

    const showFeedback = () => {
        setShowNextButton(1);
        const form = formRef.current;
        let answers = serialize(form, {hash: true});
        setAnswers(answers);
        gsap.to('.response', {x: -1600});
        gsap.set('.feedback', {display: 'block'});
        setFeedbackToggled(true);
        // if activity complete, unlock the page
        if (counter === scenarios.length - 1) {
            finished();
        }
    };

    const toggleFeedback = () => {
        setFeedbackToggled(!feedbackToggled)
    }

    const showNextPage = () => {
        setShowNextButton(0);
        setShowResponse(false);
        setFeedbackToggled(false);
        gsap.set('.video', {clearProps: 'x,y'});
        gsap.to('.questions', {x: 1600});
        gsap.to('.feedback', {x: -1600});
        gsap.from('.video', {x: -1600, delay: 1});

        setTimeout(function () {
            setShowVideo(true);
            setSelection(-1);
            let count = counter + 1;
            setCounter(count);
            setShowRater(0);
            setAnswers([]);
            setChoiceSet({});
        }, 1000);
    };

    const play = (ele) => {
        if (ele.current) {
            if (ele.current.paused) {
                ele.current.play();
            } else {
                ele.current.pause();
            }
        }
    };

    return (
        <div className="videoRating">
            {debug &&
            <div className="font-sans font-bold text-xl absolute top-3 left-3 inline-block">
                {scenarios[counter].id ? scenarios[counter].id : ''}
            </div>
            }
            {showVideo &&
            <div className="h-auto content-center video">
                <div className="VideoPlayer"
                     onClick={() => play(videoTag)}>
                    <video
                        ref={videoTag}
                        src={video}
                        autoPlay="autoplay"
                        controls
                        onEnded={() => {
                            skip();
                        }}
                    >
                        Sorry, your browser doesn't support embedded videos.
                    </video>
                </div>
            </div>
            }
            {showRater ?
                <Rater
                    slider={slider}
                    showChoices={showChoices}
                    handleSelection={handleSelection}
                /> : null}
            {showResponse &&
            <div className="response">
                <div className="VideoPlayer"
                     onClick={() => play(videoResponseTag)}>
                    <video
                        ref={videoResponseTag}
                        src={responseVideo}
                        controls
                    >
                        Sorry, your browser doesn't support embedded videos.
                    </video>
                </div>
                <StandardButton data={"Show Feedback"}
                                callback={toggleFeedback}
                                style={{
                                    "visibility": answers.length !== 0 ? "visible" : "hidden"
                                }}/>
            </div>}
            {(answers.length !== 0) ?
                (<Feedback answers={answers}
                           ref={fbComp}
                           feedback={feedback}
                           toggle={toggleFeedback}
                           choices={choices}/>) : null
            }
            {choices &&
            <Questions
                showQuestions={showQuestions}
                choices={choices}
                title={title}
                body={body}
                formRef={formRef}
                showFeedback={showFeedback}
                showNextButton={showNextButton}
            />
            }
            {(showNextButton && (counter < scenarios.length - 1)) ? (
                <StandardButton data={"Continue"}
                                callback={showNextPage}
                                style={{
                                    "position": "absolute",
                                    "bottom": "20px",
                                    "right": 0
                                }}/>) : null
            }
            {(showRater && !showQuestions) ?
                (<div className="absolute bottom-0 right-0">
                    <p className="instructions">{renderHTML(instructions)}</p>
                </div>) : null
            }
            {(!showRater && showVideo && debug) ?
                (<div className="absolute bottom-0">
                    <div className="skip-button">
                        <button onClick={() => skip()}>Skip</button>
                    </div>
                </div>) : null
            }
        </div>
    );
};

export default VideoRating;
